import { autoserializeAs } from 'cerialize';

export class ProxyCallRecording implements IProxyCallRecording {
  @autoserializeAs('call_recording_id') callRecordingId?: string | null;
  @autoserializeAs('driver_user_id') driverUserId?: number | null;
  @autoserializeAs('call_started_at') callStartedAt?: string | null;

  constructor(payload?: IProxyCallRecording) {
    this.callRecordingId = payload?.callRecordingId;
    this.driverUserId = payload?.driverUserId;
    this.callStartedAt = payload?.callStartedAt;
  }
}

export interface IProxyCallRecording {
  callRecordingId?: string | null;
  driverUserId?: number | null;
  callStartedAt?: string | null;
}
